module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ts-menuTable",
    style: ({
      'marginBottom': _vm.header ? '16px' : '0'
    })
  }, [(_vm.header) ? _c('div', {
    staticClass: "ts-menuTable-header"
  }, [_vm._t("header-left"), _vm._v(" "), _c('div', {
    staticClass: "ts-menuTable-header--right"
  }, [_vm._t("header-right")], 2)], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ts-menuTable-content",
    class: {
      'is-header': !_vm.header && !_vm.content
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-14f97b13"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/menutable/tsMenuTable.vue
// module id = 799
// module chunks = 39